import { CarPdfViewer } from "@app/components/PdfViewer";
import { useTheme } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAssetClassExtendedStat } from "../useAssetClassExtendedStat";
import { AssetClassLoadType } from "@app/features/assets/useAssetClasses";
import { CarPdfDocument } from "@app/components/PdfDocument";
import { CarPdfPage, defaultClientPageSize } from "@app/components/PdfPage";
import { CarPdfTypography } from "@app/components/PdfTypography";
import { useUser } from "@app/pages/settings/useUser";
import { OutUnderPerformancePdfChart } from "./OutUnderPerformancePdfChart";
import { assetClassAnalysisPages } from "@app/const/route.const";

export const OUT_UNDER_PERFORMANCE_CHART_HEIGHT = 176;

export const PdfPerformanceRiskReportPage = () => {
  const [searchParams] = useSearchParams();
  const { assetClass1Id, assetClass2Id, startYear, endYear } =
    assetClassAnalysisPages.getPdfPerformanceRiskReportParams(searchParams);

  const data = useAssetClassExtendedStat({
    type: AssetClassLoadType.byLatestSimulationJob,
    filterByUsableInPortfolios: true,
  });

  const title = data.oneYearUnderPerf.find(
    (i) => i.id === assetClass1Id,
  )?.label;

  const user = useUser();

  const footer = "Asset Class Analysis";

  return (
    <CarPdfViewer isLoading={user.isLoading || data.isLoading}>
      <CarPdfDocument title={title} author={user.userFullName}>
        {
          <CarPdfPage
            sectionTitle="Historical Analysis"
            reportTitle="Performance Risk"
            footer={footer}
          >
            <CarPdfTypography
              variant="v14Semibold"
              dense
              style={{ marginTop: 16 }}
            >
              {`1 Year Underperformance Risk: ${startYear} - ${endYear}`}
            </CarPdfTypography>
            <OutUnderPerformancePdfChart
              style={{ marginTop: 14 }}
              width={defaultClientPageSize.width}
              height={OUT_UNDER_PERFORMANCE_CHART_HEIGHT}
              data={data.oneYearUnderPerf}
              periods={data.periods}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
              startYear={startYear}
              endYear={endYear}
              isRelative={false}
              isWhiteContext
            />
            <CarPdfTypography
              variant="v14Semibold"
              dense
              style={{ marginTop: 50 }}
            >
              {`3 Year Underperformance Risk: ${startYear} - ${endYear}`}
            </CarPdfTypography>
            <OutUnderPerformancePdfChart
              style={{ marginTop: 14 }}
              width={defaultClientPageSize.width}
              height={OUT_UNDER_PERFORMANCE_CHART_HEIGHT}
              data={data.threeYearUnderPerf}
              periods={data.periods}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
              startYear={startYear}
              endYear={endYear}
              isRelative={false}
              isWhiteContext
            />
            <CarPdfTypography
              break
              variant="v14Semibold"
              dense
              style={{ marginTop: 8 }}
            >
              {`Cumulative Relative Performance: ${startYear} - ${endYear}`}
            </CarPdfTypography>
            <OutUnderPerformancePdfChart
              style={{ marginTop: 14 }}
              width={defaultClientPageSize.width}
              height={OUT_UNDER_PERFORMANCE_CHART_HEIGHT}
              data={data.cumRelPerf}
              periods={data.periods}
              data1Id={assetClass1Id}
              data2Id={assetClass2Id}
              startYear={startYear}
              endYear={endYear}
              isRelative={true}
              isWhiteContext
            />
          </CarPdfPage>
        }
      </CarPdfDocument>
    </CarPdfViewer>
  );
};
